import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from './CartContext'; // Ensure correct import path

function Navbar() {
  const { cartItems } = useCart();

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="container px-4 px-lg-5">
        <Link className="navbar-brand" to="/">Ntrepid Design</Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0 ms-lg-4">
            <li className="nav-item"><Link className="nav-link active" aria-current="page" to="/">Home</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/men">Men</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/Women">Women</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/accessories_collectibles">Accessories and Collectibles</Link></li>
            <li className="nav_item"><Link className="nav-link" to="/size-guide">Size Guide</Link></li>
            <li className="nav-item"><Link className="nav-link" to="/About">About</Link></li>
          </ul>
          <form className="d-flex">
            <Link className="btn btn-outline-dark" to="/cart">
              <i className="bi-cart-fill me-1"></i>
              Cart
              <span className="badge bg-dark text-white ms-1 rounded-pill">{cartItems.length}</span>
            </Link>
          </form>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;

